const form = getElById('form');
const username = getElById('username');
const email = getElById('email');
const tel = getElById('tel');
const agreement = getElById('agreement');
const message = getElById('message');
const alertMessage = getElById('alertMessage');
const submitBtn = getElById('submit-button');
const formInputs = [username, tel, email, message];

let isAllowed = false;

function checkRequired(inputArr) {
  inputArr.forEach((input) => {
    checkClass(input.parentElement, 'error');
    checkClass(input.parentElement, 'success');

    if (input.value.trim() === '') {
      input.parentElement.classList.add('error');
    } else {
      input.parentElement.classList.add('success');
    }
  });
}

function handleValidation(inputs) {
  const formValid = inputs.every((input) => input.value);

  checkClass(alertMessage, 'success');
  checkClass(alertMessage, 'error');

  if (formValid) {
    if (!isAllowed) {
      alert('Accept terms');
      return;
    }

    Email.send({
      SecureToken: '89e91ae4-a211-442a-8bad-f663ec476484',
      To: 'jagiellokatia@gmail.com',
      From: email.value,
      Subject: 'Contact form',
      Body: `Numer telefonu: ${tel.value}, ${message.value}`,
    }).then(() => formSuccess());
  } else {
    formError();
  }
}

function checkClass(element, className) {
  element.classList.contains(className) && element.classList.remove(className);
}

function formSuccess() {
  alertMessage.classList.add('success');
  alertMessage.textContent = '*Wiadomość została wysłana';

  setTimeout(() => {
    username.value = '';
    email.value = '';
    tel.value = '';
    message.value = '';

    formInputs.forEach((input) => {
      input.parentElement.classList.remove('success');
    });

    alertMessage.classList.remove('success');
    alertMessage.textContent = '';
  }, 5000);
}

function formError() {
  alertMessage.classList.add('error');
  alertMessage.textContent = '*Pola wymagane';
  !isAllowed && alert('Zaakceptuj warunek');
}

function getElById(id) {
  return document.getElementById(id);
}

agreement.addEventListener('change', () => {
  isAllowed = !isAllowed;
});

form.addEventListener('submit', function (event) {
  event.preventDefault();
  checkRequired(formInputs);
  handleValidation(formInputs);
});
